import { render, staticRenderFns } from "./museum.vue?vue&type=template&id=50a5dae4&"
import script from "./museum.vue?vue&type=script&lang=js&"
export * from "./museum.vue?vue&type=script&lang=js&"
import style0 from "./museum.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports